import { render, staticRenderFns } from "./MatchedContact.vue?vue&type=template&id=12373ef4&scoped=true"
import script from "./MatchedContact.vue?vue&type=script&lang=js"
export * from "./MatchedContact.vue?vue&type=script&lang=js"
import style0 from "./MatchedContact.vue?vue&type=style&index=0&id=12373ef4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12373ef4",
  null
  
)

export default component.exports